import { createFileRoute, Outlet, redirect } from "@tanstack/react-router";
import { AppSidebar } from "@/components/app-sidebar";
import { authClient } from "@/lib/auth-client";

/**
 * Pathless layout route: every child is guarded, and the guard runs before the
 * route's loader — so protected loaders never fire for signed-out visitors.
 */
export const Route = createFileRoute("/_authed")({
  beforeLoad: async ({ location }) => {
    const { data } = await authClient.getSession();
    if (!data) {
      throw redirect({ to: "/login", search: { redirect: location.href } });
    }
    return { user: data.user };
  },
  component: AuthedLayout,
});

function AuthedLayout() {
  return (
    <div className="flex flex-1">
      <AppSidebar />
      {/* A flex column so a page can fill the height with `flex-1` (the
          conversation view pins its composer to the bottom this way). Pages
          centred with `mx-auto` need `w-full`, or auto margins shrink them. */}
      <main className="flex min-w-0 flex-1 flex-col">
        <Outlet />
      </main>
    </div>
  );
}
